import { environment } from '@env/insitestore360';

export const USER_URL: string = `${environment.apiUrl}/user-service`;
export const STORE_URL: string = `${environment.apiUrl}/store-service`;
export const PRODUCT_URL: string = `${environment.apiUrl}/product-service`;
export const SURVEY_URL: string = `${environment.apiUrl}/survey-service`;
export const BLOB_URL: string = `${environment.apiUrl}/blob-service`;
export const RawData_URL: string = `${environment.apiUrl}/row-data-service`;
export const STORE_360_URL: string = `${environment.apiUrl}/store360-service`;
export const STORE_360_AUTH_URL: string = `${environment.apiUrl}/auth`;
export const JBP_URL: string = `${environment.apiUrl}/jbp-service`;
export const SALES_DASHBOARD_URL: string = `${environment.apiUrl}/salesdashboard-service`;

export const TARGET_SETTING_URL: string = `${environment.apiUrl}/survey-service/targetIncentive`;
export const TASK_LIST_URL: string = `${environment.apiUrl}/survey-service/taskList`;
export const SURVEY_SERVICE_URL: string = `${environment.apiUrl}/survey-service`;
export const TRAINING_URL: string = `${environment.apiUrl}/training-service`;
export const PROJECT_MANAGEMENT_URL: string = `${environment.apiUrl}/project-management-service`;
export const EWARRANTY_URL: string = `${environment.apiUrl}/ewarranty-service`;
export const TRADE_ACTIVITY_URL: string = `${environment.apiUrl}/trade-activity-service`;
export const SPFT_URL: string = `${environment.apiUrl}/spft-service`;
export const PROMOTER_COST_URL: string = `${environment.apiUrl}/user-service/promoterCost`;
